<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :pathResource="pathResource">
        <template slot="toolbar-title">

            <rsa-ospite-anagrafica-component :jsonData="jsonData.accettazione"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
                        <label class="sa-label-data">NRE</label>
                        <b-form-input v-model="filtro.codiceBar2"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2" v-if="completeBookingSsn">
                        <label class="sa-label-data">Agenda</label>
                        <b-form-select v-model="filtro.idAgenda" @change="onChangeAgendaFiltro" :options="agendeOptions"
                            text-field="titolo" value-field="id"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
                        <label class="sa-label-data">Prestazione</label>
                        <b-form-select v-model="filtro.prestazione" :options="agendaPrestazioniOptions"
                            text-field="descrizionePrestazione" value-field="codicePrestazione">
                            <template #first>
                                <b-form-select-option :value="null">- TUTTE -</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                        <label class="sa-label-data">Data dal:</label>
                        <date-picker v-model="filtro.dataRiferimentoDal" format="DD-MM-YYYY" value-type="timestamp"
                            placeholder="Seleziona data iniziale" type="date"> </date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                        <label class="sa-label-data">Data al:</label>
                        <date-picker v-model="filtro.dataRiferimentoAl" format="DD-MM-YYYY" value-type="timestamp"
                            placeholder="Seleziona data finale" type="date"> </date-picker>
                    </b-col>

                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"
                        class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button v-on:click="onReset" variant="danger">{{
                            this.$i18n.t("patients.lblResetFilter")
                        }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <AccettazionePrestazioniListComponent ref="cmpAccettazionePrestazioneListComponent" />
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";

import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import AccettazionePrestazioniListComponent from "../../../accettazione/appuntamenti/components/AccettazionePrestazioniListComponent.vue";
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
import PresidiPrestazioniMixins from "../../../strutture/presidiprestazioni/mixins/PresidiPrestazioniMixins.js";
export default {
    mixins: [UtilityMixin, PresidiPrestazioniMixins],
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    props: {
        utente: { type: Object },
    },
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        DatePicker,
        AccettazionePrestazioniListComponent
    },
    data() {
        return {
            idAccettazione: null,
            filtro: {
                dataRiferimentoDal: new Date().getTime(),
                dataRiferimentoAl: new Date().getTime(),
                codiceBar2: null,
                idAgenda: null,
                prestazione: null,
                idAccettazione: null,
            },
            jsonDataAccettazione: {},
            agendeOptions: [],
            agendaPrestazioniOptions: [],
            btnNewVisible: true,
            pathResource: "/progettoriabilitativoindividuale",
            pathResourceAccettazione: "/accettazioni",
            linkback: "/rsagestioneospiti",
            listKey: 0,
            presidio: {},
            jsonData: { accettazione: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} }, accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {}, ricette: [] },
            statiPriOptions: [],
            completeBookingSsn: this.appConfig.completeBookingSSN,
        };
    },
    mounted() {
        this.setPresidio();
        this.idAccettazione = this.$route.query.idAccettazione;
        this.loadAccettazione();

        const oggi = new Date();
        oggi.setHours(23, 59, 59, 999);
        const fineOggiLong = oggi.getTime();
        const inizioSettimanaScorsa = new Date();
        inizioSettimanaScorsa.setDate(inizioSettimanaScorsa.getDate() - 7);
        inizioSettimanaScorsa.setHours(0, 0, 0, 0);
        const inizioSettimanaScorsaLong = inizioSettimanaScorsa.getTime();
        this.filtro.dataRiferimentoDal = inizioSettimanaScorsaLong;
        this.filtro.dataRiferimentoAl = fineOggiLong;
        this.filtro.idAccettazione = this.idAccettazione;

    },
    methods: {

        setPresidio() {
            let tmpPresidio = window.localStorage.getItem("presidio");
            if (tmpPresidio) {
                this.presidio = JSON.parse(tmpPresidio);
            }
        },
        loadAccettazione() {
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.pathResourceAccettazione + "/" + this.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    this.jsonData.accettazione = response.data.data;
                    this.setDatiAppuntamento();
                    this.closeShowModalLoading();

                    if (this.completeBookingSsn) {
                        this.loadAgende();

                    } else {
                        this.loadPrestazioniPresidio()
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        setDatiAppuntamento() {
            let filter = {

                barcode: this.jsonData.accettazioneAnagrafica.identificativo,
                cf: this.jsonData.accettazioneAnagrafica.identificativo,
                dataRiferimentoDal: this.filtro.dataRiferimentoDal,
                dataRiferimentoAl: this.filtro.dataRiferimentoAl,
                codiceBar2: this.filtro.codiceBar2,
                idAgenda: this.filtro.idAgenda,
                prestazione: this.filtro.prestazione,
                idAccettazione: this.filtro.idAccettazione
            }
            this.$refs.cmpAccettazionePrestazioneListComponent.init(filter, null);

        },
        onSubmit() {
            this.setDatiAppuntamento();
        },
        loadPrestazioniPresidio() {
            this.agendaPrestazioniOptions = [];
            PresidiPrestazioniMixins.methods.loadPrestazioniPresidioByCodicePresidio(this.jsonData.accettazionePresidio.codicePresidio, this.callBackSuccessLoadPresidiPrestazioni);

        },
        callBackSuccessLoadPresidiPrestazioni(response) {
            let prestazioni = response.data.data.list.map(item => ({
                codicePrestazione: item.codice,
                descrizionePrestazione: item.descrizione,
            }));

            this.agendaPrestazioniOptions = prestazioni;


        },
        onReset() {
            const oggi = new Date();
            oggi.setHours(23, 59, 59, 999);
            const settimanaScorsa = new Date();
            settimanaScorsa.setDate(settimanaScorsa.getDate() - 7);
            settimanaScorsa.setHours(0, 0, 0, 0);
            this.filtro = {
                idAccettazione: this.filtro.idAccettazione,
                dataRiferimentoDal: settimanaScorsa.getTime(),
                dataRiferimentoAl: oggi.getTime(),
                codiceBar2: null,
                idAgenda: null,
                prestazione: null
            };

            this.setDatiAppuntamento();

        },
        loadAgende() {
            this.agendeOptions = [];
            this.loadDataResources("/agende", { idPresidio: this.presidio.idPresidio }, this.loadAgendeSuccess, this.loadAgendeError);
        },
        loadAgendeSuccess(response) {
            this.agendeOptions = response.data.data;
        },
        loadAgendeError(error) {
            console.log(error);
        },
        onChangeAgendaFiltro(id) {
            this.loadAgendePrestazioni(id)
        },

        loadAgendePrestazioni(id) {
            this.agendaPrestazioniOptions = [];
            this.loadDataResources("/agendaprestazioni?idAgenda=" + id, {}, this.loadAgendePrestazioniSuccess, this.loadAgendePrestazioniError);
        },
        loadAgendePrestazioniSuccess(response) {
            this.agendaPrestazioniOptions = response.data.data;
        },
        loadAgendePrestazioniError(error) {
            console.log(error);
        },
    },
};
</script>

<style></style>
